import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { Trans } from "react-i18next";
import { connect, useSelector } from "react-redux";
import { formValueSelector } from "redux-form";
import { Card, CardTitle } from "reactstrap";
import NumericFormat from "../../../../components/react-number-format/NumericFormat";
import { loadFirstBrokerCurrencyGoalInvestmentItemUserBalanceByBrokerIdAndCurrencyIdAndGoalIdAndInvestmentItemIdAndUserIdOrderByInstantDesc, loadOperationsByBrokerIdAndGoalIdAndUserIdAndStateIdIn } from "../../../../actions";
import { engagedOperationStateIdsStr, operationTypes } from "../../../../constants";
var tKey = "contexts.ExchangeContext.CreateExchangeDialog.ExchangeWizardForm.ExchangeWizardFormAmountAvailableBuyStep";
var selector = formValueSelector("exchangeWizard");
function ExchangeWizardFormAmountAvailableBuyStep(props) {
  var authUserId = useSelector(function (state) {
    return state.authentication.userId;
  });
  var broker = useSelector(function (state) {
    return selector(state, "broker");
  });
  var brokerId = broker.id;
  var price = useSelector(function (state) {
    return selector(state, "price");
  });
  var currency = price.currency;
  var currencyId = currency.id;
  var goal = useSelector(function (state) {
    return selector(state, "goal");
  });
  var goalId = goal.id;
  var goalIdStr = goalId === -1 ? "null" : goalId;
  var balance = useSelector(function (state) {
    return state.entities.brokerCurrencyGoalInvestmentItemUserBalances.firstByBrokerIdAndCurrencyIdAndGoalIdAndInvestmentItemIdAndUserIdOrderByInstantDesc[[brokerId, currencyId, goalIdStr, currencyId, authUserId].join("-")];
  });
  var balanceInvestmentItemAmount = balance ? balance.investmentItemAmount : 0;
  var engagedOperations = useSelector(function (state) {
    return state.entities.operations.byBrokerIdAndGoalIdAndUserIdAndStateIdIn[[brokerId, goalIdStr, authUserId, engagedOperationStateIdsStr].join("-")];
  }) || [];
  var engagedCurrencyAmount = engagedOperations.filter(function (operation) {
    return operation.type === operationTypes.BUY && operation.currency.id === currencyId;
  }).reduce(function (accumulator, _ref) {
    var roundedCurrencyAmount = _ref.roundedCurrencyAmount;
    return accumulator + roundedCurrencyAmount;
  }, 0);
  var engagedInvestmentItemAmount = engagedOperations.filter(function (operation) {
    return operation.investmentItemAmount < 0 && operation.investmentItem.id === currencyId;
  }).reduce(function (accumulator, _ref2) {
    var investmentItemAmount = _ref2.investmentItemAmount;
    return accumulator + investmentItemAmount;
  }, 0);
  engagedCurrencyAmount = engagedCurrencyAmount + Math.abs(engagedInvestmentItemAmount);
  var currencyAmountAvailable = balanceInvestmentItemAmount - engagedCurrencyAmount;
  useEffect(function () {
    props.loadFirstBrokerCurrencyGoalInvestmentItemUserBalanceByBrokerIdAndCurrencyIdAndGoalIdAndInvestmentItemIdAndUserIdOrderByInstantDesc(brokerId, currencyId, goalId === -1 ? null : goalId, currencyId, authUserId);
    props.loadOperationsByBrokerIdAndGoalIdAndUserIdAndStateIdIn(brokerId, goalId === -1 ? null : goalId, authUserId, engagedOperationStateIdsStr);
  }, [goalId, brokerId]);
  useMemo(function () {
    props.change("currencyAmountAvailable", currencyAmountAvailable);
    props.change("engagedCurrencyAmount", engagedCurrencyAmount);
  }, [currencyAmountAvailable, engagedCurrencyAmount]);
  return /*#__PURE__*/React.createElement(Card, {
    body: true,
    inverse: true,
    color: "brand-primary",
    className: "m-0 rounded"
  }, /*#__PURE__*/React.createElement(CardTitle, {
    tag: "h4",
    className: "m-0"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NumericFormat, {
    displayType: "text",
    value: currencyAmountAvailable,
    className: "me-1",
    style: {
      fontWeight: 600
    }
  }), /*#__PURE__*/React.createElement("small", null, currency.unitAbbreviation)), engagedCurrencyAmount !== 0 && /*#__PURE__*/React.createElement("div", {
    className: "small"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "".concat(tKey, ".committedBuy"),
    components: {
      amount: /*#__PURE__*/React.createElement(NumericFormat, {
        displayType: "text",
        value: engagedCurrencyAmount,
        style: {
          fontWeight: 600
        }
      })
    },
    values: {
      unitAbbreviation: currency.unitAbbreviation
    }
  }))));
}
export default connect(undefined, {
  loadFirstBrokerCurrencyGoalInvestmentItemUserBalanceByBrokerIdAndCurrencyIdAndGoalIdAndInvestmentItemIdAndUserIdOrderByInstantDesc: loadFirstBrokerCurrencyGoalInvestmentItemUserBalanceByBrokerIdAndCurrencyIdAndGoalIdAndInvestmentItemIdAndUserIdOrderByInstantDesc,
  loadOperationsByBrokerIdAndGoalIdAndUserIdAndStateIdIn: loadOperationsByBrokerIdAndGoalIdAndUserIdAndStateIdIn
})(ExchangeWizardFormAmountAvailableBuyStep);
ExchangeWizardFormAmountAvailableBuyStep.propTypes = {
  loadFirstBrokerCurrencyGoalInvestmentItemUserBalanceByBrokerIdAndCurrencyIdAndGoalIdAndInvestmentItemIdAndUserIdOrderByInstantDesc: PropTypes.func,
  loadOperationsByBrokerIdAndGoalIdAndUserIdAndStateIdIn: PropTypes.func
};